import React from "react";
import { Link, Outlet, Navigate } from "react-router-dom";
import "./css/styles.css";
import { useLocation } from "react-router-dom";

// import { auth } from "../firebase";
//import {signOut } from "firebase/auth";
// import logo from "./logo.png";
// import SportsGymnasticsIcon from "@mui/icons-material/SportsGymnastics";
// import DomainIcon from "@mui/icons-material/Domain";
// import QueueIcon from "@mui/icons-material/Queue";
// import LogoutIcon from "@mui/icons-material/Logout";
// import StarPurple500Icon from "@mui/icons-material/StarPurple500";
// import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { useAuth } from "./AuthContext";
import { userProfile } from "./AuthContext";

export default function Navigation() {
  const { logout } = useAuth();
  const { currentUser } = useAuth();
  // console.log(currentUser);
  const handelLogout = async () => {
    try {
      await logout();
      <Navigate to="/" />;
    } catch (error) {
      alert("Error" + error.code);
    }
  };
  const path = useLocation();
  const active = path.pathname;
  return (
    <React.Fragment>
      <div id="layoutSidenav">
        <div id="layoutSidenav_nav">
          <nav
            style={{ backgroundColor: "#212C62" }}
            className="sb-sidenav accordion bg"
            id="sidenavAccordion"
          >
            <div
              style={{
                height: "calc(100vh - 0px)",
                overflow: "auto",
              }}
              className="sb-sidenav-menu"
            >
              <div className="nav ps-2">
                <div className="sb-sidenav-menu-heading">
                  <div className="text-light" style={{ marginBottom: 40 }}>
                    <div className="ms-3">
                      <div style={{ width: "100px", position: "relative" }}>
                        <img
                          className="rounded-4 "
                          src={currentUser?.photoURL}
                          width="100%"
                        />
                        <div
                          style={{
                            backgroundColor: "#DC3434",
                            color: "#ffffff",
                            width: "30px",
                            height: "30px",
                            borderRadius: "50%",
                            fontSize: "20px",
                            position: "absolute",
                            top: "-10px",
                            right: "-10px",
                          }}
                        >
                          <center>4</center>
                        </div>
                      </div>

                      <h2>{currentUser?.displayName}</h2>

                      <small>{currentUser?.email}</small>
                    </div>
                  </div>
                </div>

                <Link
                  className={`nav-link sidenavtext ${
                    active === "/Dashboard" ? "active-nav-link" : " "
                  } `}
                  to="/Dashboard"
                >
                  Dashboard
                </Link>
                <Link
                  className={`nav-link sidenavtext ${
                    active === "/Categories" ? "active-nav-link" : " "
                  } `}
                  to="/Categories"
                >
                  Categories
                </Link>

                <Link
                  className={`nav-link sidenavtext ${
                    active === "/AllProducts" ? "active-nav-link" : " "
                  } `}
                  to="/AllProducts"
                >
                  Products
                </Link>

                <Link
                  className={`nav-link sidenavtext ${
                    active === "/AllServices" ? "active-nav-link" : " "
                  } `}
                  to="/AllServices"
                >
                  Services
                </Link>
                <Link
                  className={`nav-link sidenavtext ${
                    active === "/AllFeedbacks" ? "active-nav-link" : " "
                  } `}
                  to="/AllFeedbacks"
                >
                  Reviews
                </Link>
                <Link
                  className={`nav-link sidenavtext ${
                    active === "/AllOrders" ? "active-nav-link" : " "
                  } `}
                  to="/AllOrders"
                >
                  Orders
                </Link>
                <Link
                  className={`nav-link sidenavtext ${
                    active === "/AllUsers" ? "active-nav-link" : " "
                  } `}
                  to="/AllUsers"
                >
                  Users
                </Link>
                <Link
                  className={`nav-link sidenavtext ${
                    active === "/DiplomaticList" ? "active-nav-link" : " "
                  } `}
                  to="/DiplomaticList"
                >
                  Diplomatic List Per Country
                </Link>
                <Link
                  className={`nav-link sidenavtext ${
                    active === "/AddBooks" ? "active-nav-link" : " "
                  } `}
                  to="/AddBooks"
                >
                  Books & Textbooks
                </Link>
                <Link
                  className={`nav-link sidenavtext ${
                    active === "/AddScholarship" ? "active-nav-link" : " "
                  } `}
                  to="/AddScholarship"
                >
                  Scholarships
                </Link>
                <Link
                  className={`nav-link sidenavtext ${
                    active === "/AddSchools" ? "active-nav-link" : " "
                  } `}
                  to="/AddSchools"
                >
                  Schools per Country
                </Link>
                <Link
                  className={`nav-link sidenavtext ${
                    active === "/AddCuturalResources" ? "active-nav-link" : " "
                  } `}
                  to="/AddCuturalResources"
                >
                  Cultural Resources per Country
                </Link>
                <Link
                  className={`nav-link sidenavtext ${
                    active === "/newsfeed" ? "active-nav-link" : " "
                  } `}
                  to="/newsfeed"
                >
                  News Feed
                </Link>
                <Link
                  className={`nav-link sidenavtext ${
                    active === "/ConventionAndTreaties"
                      ? "active-nav-link"
                      : " "
                  } `}
                  to="/ConventionAndTreaties"
                >
                  Convention And Treaties
                </Link>
                <Link
                  className={`nav-link sidenavtext ${
                    active === "/Institutions" ? "active-nav-link" : " "
                  } `}
                  to="/Institutions"
                >
                  Institutions
                </Link>
                <Link
                  className={`nav-link sidenavtext ${
                    active === "/UNResolutions" ? "active-nav-link" : " "
                  } `}
                  to="/UNResolutions"
                >
                  UN Resolutions
                </Link>
                <Link
                  className={`nav-link sidenavtext ${
                    active === "/visarequirement" ? "active-nav-link" : " "
                  } `}
                  to="/visarequirement"
                >
                  Visa Requirement
                </Link>
                <Link
                  className={`nav-link sidenavtext ${
                    active === "/Countries" ? "active-nav-link" : " "
                  } `}
                  to="/Countries"
                >
                  Countries
                </Link>
                <Link
                  className={`nav-link sidenavtext ${
                    active === "/Codes" ? "active-nav-link" : " "
                  } `}
                  to="/Codes"
                >
                  Subscription Codes
                </Link>
                <Link
                  className={`nav-link sidenavtext ${
                    active === "/SendEmails" ? "active-nav-link" : " "
                  } `}
                  to="/SendEmails"
                >
                  Send Custom Email
                </Link>
                <Link
                  className={`nav-link sidenavtext ${
                    active === "/SendNotifications" ? "active-nav-link" : " "
                  } `}
                  to="/SendNotifications"
                >
                  Send Custom Notifications
                </Link>
                <Link
                  className={`nav-link sidenavtext ${
                    active === "/ManageSubscription" ? "active-nav-link" : " "
                  } `}
                  to="/ManageSubscription"
                >
                  Manage Subscription
                </Link>
                <Link
                  className={`nav-link sidenavtext ${
                    active === "/settings" ? "active-nav-link" : " "
                  } `}
                  to="/settings"
                >
                  Settings
                </Link>

                <Link
                  className="nav-link sidenavtext "
                  to="/"
                  onClick={() => handelLogout()}
                >
                  Logout
                </Link>
              </div>
            </div>
          </nav>
        </div>
        <div
          style={{
            width: "100%",
            height: "calc(100vh - 0px)",
            overflow: "auto",
            backgroundColor: "#212C62",
          }}
        >
          <Outlet />
        </div>
      </div>
    </React.Fragment>
  );
}
